const schema = () => ({
  title: 'CTA réservation',
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['eyebrow', 'heading', 'description'],
    },
  ],
  properties: {
    eyebrow: {
      title: 'Sur-titre',
      type: 'string',
      default: 'Réserver une table',
    },
    heading: {
      title: 'Titre',
      type: 'string',
      default: 'Composez pour réserver, on vous garde la table qui convient.',
    },
    description: {
      title: 'Description',
      type: 'string',
      default: 'Permanence téléphonique du mardi au samedi, de 10h à 19h.',
    },
  },
  required: [],
});

export default schema;
